import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change } from "redux-form";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

import "./myWorkout.scss";
import FilterPanel, { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { FormField } from "../../../sharedComponents/formField";
import { resetField, editExerciseSchedule, getMyWorkouts } from "../../../store/actions";
import { editExerciseFields } from "./formHelper";

export const EditExercise = ({
	resetField,
	editExerciseSchedule,
	toggleEditPanel,
	initialValues,
	handleSubmit,
	getMyWorkouts,
	change,
	form
}) => {
	const days_of_week = [
		'monday',
		'tuesday',
		'wednesday',
		'thursday',
		'friday',
		'saturday',
		'sunday'
	]
	const updateExercise = (values) => {
		Object.keys(values).forEach(function(key, index) {
			if(days_of_week.includes(key)) {
				if(values[key]) {
					values[key] = 1
				} else {
					values[key] = 0
				}
			}
		});
		if (JSON.stringify(initialValues) !== JSON.stringify(values)) {
			resetField("MyWorkout.toggleEditPanel", false);
			const successHandler = (res) => {
				NotificationManager.success("Exercise updated!", "", 5000);
				getMyWorkouts();
			};
			editExerciseSchedule({ ...values, is_plan: 1 }, successHandler);
		} else {
			NotificationManager.warning("Nothing to update!", "", 5000);
		}
	};

	return (
		<React.Fragment>
			<FilterPanel
				className="add-exercise-panel hide-sub-header"
				show={toggleEditPanel}
				toggle={() => resetField("MyWorkout.toggleEditPanel", false)}
				title={initialValues && initialValues.exercise_data && initialValues.exercise_data.name}
				closeBtn>
				<form onSubmit={handleSubmit(updateExercise)}>
					<PanelBody>
						<div className="row mb-3">
							<div className="col-12">
								Select the days of the week you plan to perform this exercise.
							</div>
						</div>
						<div className="row">
							{editExerciseFields.map((input, index) => (
								<Field
									key={index}
									{...input}
									onChange={(event) => {
										!event.target.value &&
											setTimeout(() => {
												change(form, input.name, 0);
											});
									}}
									type="checkbox"
									formGroupClass="col-12"
									component={FormField}
								/>
							))}
						</div>
					</PanelBody>
					<PanelFooter className="sticky-footer d-flex justify-content-end">
						<button className="btn" type="button" onClick={() => resetField("MyWorkout.toggleEditPanel", false)}>
							Cancel
						</button>
						<button type="submit" className="btn btn-primary">
							Save Now
						</button>
					</PanelFooter>
				</form>
			</FilterPanel>
		</React.Fragment>
	);
};

const mapDispatchToProps = { resetField, editExerciseSchedule, getMyWorkouts, change };
const mapStateToProps = (state) => {
	const { MyWorkout } = state;
	return {
		toggleEditPanel: get(MyWorkout, "toggleEditPanel")
	};
};

export default reduxForm({
	form: "EditExerciseForm",
	enableReinitialize: true
})(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(EditExercise)
);
